module.exports = __webpack_public_path__ + "img/drops_460.4de79e07.png";